import React from 'react';
import BaseReport from './BaseReport';

type Props = {
  data: any;
  studentNameMap?: { [studentId: string]: string };
};

const StandardReport = ({ data, studentNameMap }: Props) => {
  return (
    <BaseReport
      data={data}
      studentNameMap={studentNameMap}
      reportType="standard"
      showNoData={true}
      alwaysShowThreshold={false}
    />
  );
};

export default StandardReport;
